// extracted by mini-css-extract-plugin
module.exports = {"container":"ToggleSwitch_container__1Bx26"};